import config from "src/config";
import VConsole from "vconsole";

let vConsole = null;
if (config.vconsole.enabled) {
  vConsole = new VConsole();
}

export default vConsole;
